module.exports = __webpack_public_path__ + "static/media/washington-dc-37.af328714.jpg";